import React, { FC } from 'react';
import cn from 'classnames';
import NextImage from 'src/shared-components/NextImage/NextImage';

interface Props {
  id: string;
  title: string;
  subTitle?: string;
  icon?: string;
  selected?: boolean;
  rotatedIcon?: boolean;
  bgDarkStyle?: boolean;
}

const Item: FC<Props> = ({
  id,
  selected = false,
  title,
  subTitle = null,
  icon = null,
  bgDarkStyle = false
}) => (
  <span
    className={cn(
      'w-full flex justify-between items-center fs-caption-reg text-left py-2.5 px-3 space-x-2',
      {
        'text-white': bgDarkStyle,
        'text-stratos': !bgDarkStyle
      }
    )}
  >
    <span className="fs-body-reg">{title}</span>
    {subTitle && <span className="fs-body-bold">{subTitle}</span>}
    {selected && (
      <NextImage alt={`sort by ${id}`} src={icon} height={13} width={17} />
    )}
  </span>
);

export default Item;
